import { render, staticRenderFns } from "./article-text.vue?vue&type=template&id=811f65ca&lang=pug&"
import script from "./article-text.vue?vue&type=script&lang=js&"
export * from "./article-text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports